export interface TenantOption {
  id: string;
  label: string;
}

/** Admin list scope — all tenants aggregated (guests/users tables show tenant column). */
export const ALL_TENANTS_ID = 'all';

const fallbackTenants: TenantOption[] = [
  { id: 'teristimewa-ai', label: 'Teristimewa' },
  { id: 'warisantara-ai', label: 'Warisantara' },
];

export const adminDashboardConfig = {
  /** Super-admin gateway key — same for all dashboard requests (not per-product). */
  gatewayKey: import.meta.env.VITE_ADMIN_DASHBOARD_KEY ?? 'secret-ai-core-central',
  tenantHeader: 'x-tenant-id',
  gatewayHeader: 'x-teristimewa-ai-key',
} as const;

export const tenantConfig = {
  fallbackTenants,
  defaultTenantId: ALL_TENANTS_ID,
  storageKey: 'admin_tenant_id',
} as const;

export function isAllTenants(id: string): boolean {
  return id === ALL_TENANTS_ID;
}

export function isKnownTenantId(id: string, tenants: readonly TenantOption[]): boolean {
  return isAllTenants(id) || tenants.some((tenant) => tenant.id === id);
}

export function getTenantById(
  id: string,
  tenants: readonly TenantOption[] = fallbackTenants,
): TenantOption | undefined {
  if (isAllTenants(id)) {
    return { id: ALL_TENANTS_ID, label: 'All tenants' };
  }
  return tenants.find((tenant) => tenant.id === id);
}

export function getDefaultTenant(tenants: readonly TenantOption[] = fallbackTenants): TenantOption {
  return (
    getTenantById(tenantConfig.defaultTenantId, tenants) ?? {
      id: ALL_TENANTS_ID,
      label: 'All tenants',
    }
  );
}

export function withAllTenantsOption(tenants: TenantOption[]): TenantOption[] {
  return [{ id: ALL_TENANTS_ID, label: 'All tenants' }, ...tenants];
}
